// Карусель
export function initSlideOwlCarousel(params)
{
    const carousel = params.photosTourists.querySelector('.dws_custom_carousel');
    const photos = params.photosTourists.querySelector('.photos_tourists_cont');

    if (params.modalDevise) {
        photos.remove();
        $(carousel).owlCarousel({
            loop : true, // Бесконечный скролл
            dots: false, // точки навигации
            nav: true, // Кнопки вперёд-назад
            margin: 10, // отступы по бокам
            lazyLoad: true,
            navText: ['<i class="icon-angle-left"></i>', '<i class="icon-angle-right"></i>'],
            responsive:{
                0:{
                    items: 2
                },
                600:{
                    items: 3
                },
                1000:{
                    items: 5
                }
            }
        });
    } else {
        carousel.remove();
    }

}